import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { AnalyticsService } from '../../services/analytics.service';
import { takeWhile } from 'rxjs';

export interface ImageOption {
  image: string;
  alt?: string;
  text: string;
  value: any;
  activeImage: string;
  currentImage: string;
  mobileImage: string;
  mobileActiveImage: string;
  currentMobileImage: string;
}

@Component({
  selector: 'dg-image-button',
  templateUrl: './image-button.component.html',
  styleUrls: ['./image-button.component.scss'],
})
export class ImageButtonComponent implements OnInit, OnDestroy {
  constructor(
    private elementRef: ElementRef,
    private analyticsService: AnalyticsService
  ) {}
  selectedOption: ImageOption | any = null;
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const labels: HTMLElement[] = Array.from(
      this.elementRef.nativeElement.querySelectorAll('.image_button')
    );
    const currentIndex = labels.findIndex(
      (label) => document.activeElement === label
    );

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        event.preventDefault();
        if (labels.length > 0) {
          const nextIndex = (currentIndex + 1) % labels.length;
          labels[nextIndex].focus();
        }
        break;

      case 'ArrowLeft':
      case 'ArrowUp':
        event.preventDefault();
        if (labels.length > 0) {
          const prevIndex = (currentIndex - 1 + labels.length) % labels.length;
          labels[prevIndex].focus();
        }
        break;

      case 'Enter':
      case ' ':
        if (currentIndex >= 0) {
          event.preventDefault();
          this.selectOption(this.options[currentIndex]);
          this.onClick(this.options[currentIndex]);
        }
        break;
    }
  }

  private selectOption(option: any) {
    this.buttonCtrl.setValue(option);
  }

  ngOnDestroy(): void {
    this.isAlive = false;
  }
  private isAlive = true;
  ngOnInit(): void {
    this.buttonCtrl.valueChanges
      .pipe(takeWhile(() => this.isAlive))
      .subscribe(() => {
        this.clicked.emit(this.buttonCtrl.value);
      });
  }
  @Input() options: ImageOption[] = [];
  @Input() gaData: any;
  @Output() clicked = new EventEmitter();

  buttonCtrl = new FormControl('');

  get selectedValue() {
    return (this.buttonCtrl?.value as any)?.value;
  }

  onMouseEnter(option: ImageOption) {
    option.currentImage = option.activeImage;
  }

  onMouseLeave(option: ImageOption) {
    if ((this.buttonCtrl?.value as any)?.value === option.value) return;
    option.currentImage = option.image;
  }

  onClick(option: ImageOption) {
    if (this.selectedOption) {
      this.selectedOption.currentImage = this.selectedOption.image;
      this.selectedOption.currentMobileImage = this.selectedOption.mobileImage;
    }
    this.selectedOption = option;
    option.currentImage = option.activeImage;
    option.currentMobileImage = option.mobileActiveImage;
  }
}
